import { Whatsapp, Gmail } from "@boxicons/react";
export function Footer() {
    const handleRedirect = () => {
        window.location.href = 'mailto:contacto@anfro.com.mx?subject=Asunto&body=Cuerpo%20del%20mensaje';
      };

      const handleRedirectWhatsapp = () => {
        window.location.href = 'https://wa.me/+3331587544?text=Hola!';
      };
    return (
        <section className="footer">
            <section className="top">
                <div className="logo-box">
                    <img src='/images/logos/logo-empresa.jpg' width={180} alt="logo ABP"></img>
                </div>
                <div className="about-abp-box">
                    <h2>Sobre nosotros</h2>
                    <div className="list">
                        <ul>
                            <li>
                                Desarrollo para la inversión en proyectos de infraestructura a mediano plazo.
                            </li>
                            <li>
                                Consultoría en el sector de sistemas de aire acondicionado.
                            </li>
                            <li>
                                Instalación de sistemas de aire acondicionado industrial en planta.
                            </li>
                        </ul>
                        <ul>
                            <li>
                                Elaboración, dirección y asesoría en proyectos de tipo industrial
                                comercial.
                                <br></br>
                                <br></br>
                            </li>
                            <li>
                                Detección de <br></br>mano de obra especializada.
                                <br></br>
                            </li>
                            <li>
                                Suministro de insumos en el sector industrial
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="social-media">
                    <h2>Contáctanos</h2>
                    <div className="icon-box" onClick={handleRedirect}>
                        <Gmail className="i-footer" fill="red" size="lg"/>
                    </div>
                    <div className="icon-box" onClick={handleRedirectWhatsapp}>
                    <Whatsapp className="i-footer" fill="#fff" size="lg"/>
                    </div>
                </div>
            </section>
            <section className="bottom">
                <h3>© 2026 Anfro - administradora de negocios S de RL de CV</h3>
            </section>
        </section>
    )
}